import { FC, useMemo, useEffect } from 'react'
import styles from 'components/features/external/PublicSpendingByMerchant/PublicSpendingByMerchant.styl'
import cn from 'classnames'
import { useStoreSelector, useStoreDispatch } from 'helpers/reactReduxHelpers'
import { publicFiltersSelector } from 'selectors/publicDashboardSelectors'
import { getPublicBreakdownByMerchantActionCreator } from 'actions/publicDashboardActions'
import { getItemsFromCollection } from 'helpers/normalizeHelpers'
import { KeyValueListItem, KeyValueList } from 'components/features/pfm/KeyValueList/KeyValueList'
import { getValueDynamics } from 'helpers/publicDashboardHelpers'
import { isFetchableLoading } from 'helpers/loadableHelpers'
import LoadingOverlay from 'components/atoms/preloaders/LoadingOverlay'
import { isMobileSelector } from 'selectors/viewportSelectors'
import { MOBILE_KEYVALUE_ITEMS_LIMIT } from 'constants/publicDashboard'
import { IdValueEntity } from 'interfaces'

type PublicSpendingByMerchantProps = {

}

export const PublicSpendingByMerchant: FC<PublicSpendingByMerchantProps> = (props) => {
  const {} = props

  const isMobile = useStoreSelector(isMobileSelector)
  const { incomeRange, category, location } = useStoreSelector(publicFiltersSelector)

  const dispatch = useStoreDispatch()
  useEffect(() => {
    dispatch(getPublicBreakdownByMerchantActionCreator.request({ incomeRange, category, location }))
  }, [dispatch, incomeRange, category, location])

  const byMerchantFetchable = useStoreSelector((state) => state.data.publicdashboard.breakdownByMerchant)
  const items = useMemo(() => {
    if (!byMerchantFetchable.data) {
      return null
    }

    const dataItems = getItemsFromCollection<IdValueEntity<string, number>, 'id'>(byMerchantFetchable.data.items)
      .map(({ id, value }): KeyValueListItem => ({
        name: id,
        value: `${ Math.abs(value) }%`,
        dynamics: getValueDynamics(value),
      }))

    return dataItems

  }, [byMerchantFetchable])

  const isLoading = isFetchableLoading(byMerchantFetchable)

  const preloaderChild = isLoading && (
    <LoadingOverlay />
  )

  const containerClassName = cn(styles.publicSpendingByMerchant, {
    [styles.isDesktop]: !isMobile,
    [styles.noData]: (items && !items.length) || (!items && isLoading),
  })

  const limit = isMobile ? MOBILE_KEYVALUE_ITEMS_LIMIT : undefined

  return (
    <div className={ containerClassName }>
      { items && (
        <KeyValueList
          items={ items }
          isScrollable={ !isMobile }
          limit={ limit }
        />
      )}
      { preloaderChild }
    </div>
  )
}
